
import { defineComponent } from "vue";
import { appEmits } from "@/utils/appEmits";

export default defineComponent({
  name: "Home",
  emits: appEmits,
  setup(props, context) {
    context.emit("barTitle", "IIDX Viewer");
    context.emit("barMenuIcon", []);
    context.emit("barMenuList", []);

    const twitterScript = document.createElement("script");
    twitterScript.setAttribute("src", "https://platform.twitter.com/widgets.js");
    twitterScript.setAttribute("charset", "uft-8");
    document.head.appendChild(twitterScript);
  },
});
